// Definizioni delle proprietà valide per layout e paint per ciascun tipo di layer MapLibre
// Riferimento: https://maplibre.org/maplibre-style-spec/layers/

export const VALID_LAYOUT_PROPERTIES_BY_TYPE: Record<string, string[]> = {
  fill: [
    'fill-sort-key',
    'visibility',
  ],
  line: [
    'line-cap',
    'line-join',
    'line-miter-limit',
    'line-round-limit',
    'line-sort-key',
    'visibility',
  ],
  symbol: [
    'icon-allow-overlap',
    'icon-anchor',
    'icon-ignore-placement',
    'icon-image',
    'icon-keep-upright',
    'icon-offset',
    'icon-optional',
    'icon-padding',
    'icon-pitch-alignment',
    'icon-rotate',
    'icon-rotation-alignment',
    'icon-size',
    'icon-text-fit',
    'icon-text-fit-padding',
    'symbol-avoid-edges',
    'symbol-placement',
    'symbol-sort-key',
    'symbol-spacing',
    'symbol-z-order',
    'text-allow-overlap',
    'text-anchor',
    'text-field',
    'text-font',
    'text-ignore-placement',
    'text-justify',
    'text-keep-upright',
    'text-letter-spacing',
    'text-line-height',
    'text-max-angle',
    'text-max-width',
    'text-offset',
    'text-optional',
    'text-padding',
    'text-pitch-alignment',
    'text-radial-offset',
    'text-rotate',
    'text-rotation-alignment',
    'text-size',
    'text-transform',
    'text-variable-anchor',
    'text-writing-mode',
    'visibility',
  ],
  circle: [
    'circle-sort-key',
    'visibility',
  ],
  heatmap: [
    'visibility',
  ],
  'fill-extrusion': [
    'visibility',
  ],
  raster: [
    'visibility',
  ],
  hillshade: [
    'visibility',
  ],
  background: [
    'visibility',
  ],
};

export const VALID_PAINT_PROPERTIES_BY_TYPE: Record<string, string[]> = {
  fill: [
    'fill-antialias',
    'fill-color',
    'fill-opacity',
    'fill-outline-color',
    'fill-pattern',
    'fill-translate',
    'fill-translate-anchor',
  ],
  line: [
    'line-blur',
    'line-color',
    'line-dasharray',
    'line-gap-width',
    'line-gradient',
    'line-offset',
    'line-opacity',
    'line-pattern',
    'line-translate',
    'line-translate-anchor',
    'line-width',
    'line-trim-offset',
  ],
  symbol: [
    'icon-color',
    'icon-halo-blur',
    'icon-halo-color',
    'icon-halo-width',
    'icon-opacity',
    'icon-translate',
    'icon-translate-anchor',
    'text-color',
    'text-halo-blur',
    'text-halo-color',
    'text-halo-width',
    'text-opacity',
    'text-translate',
    'text-translate-anchor',
  ],
  circle: [
    'circle-blur',
    'circle-color',
    'circle-opacity',
    'circle-pitch-alignment',
    'circle-pitch-scale',
    'circle-radius',
    'circle-stroke-color',
    'circle-stroke-opacity',
    'circle-stroke-width',
    'circle-translate',
    'circle-translate-anchor',
  ],
  heatmap: [
    'heatmap-color',
    'heatmap-intensity',
    'heatmap-opacity',
    'heatmap-radius',
    'heatmap-weight',
  ],
  'fill-extrusion': [
    'fill-extrusion-base',
    'fill-extrusion-color',
    'fill-extrusion-height',
    'fill-extrusion-opacity',
    'fill-extrusion-pattern',
    'fill-extrusion-translate',
    'fill-extrusion-translate-anchor',
    'fill-extrusion-vertical-gradient',
  ],
  raster: [
    'raster-brightness-max',
    'raster-brightness-min',
    'raster-contrast',
    'raster-fade-duration',
    'raster-hue-rotate',
    'raster-opacity',
    'raster-resampling',
    'raster-saturation',
  ],
  hillshade: [
    'hillshade-accent-color',
    'hillshade-exaggeration',
    'hillshade-highlight-color',
    'hillshade-illumination-anchor',
    'hillshade-illumination-direction',
    'hillshade-shadow-color',
  ],
  background: [
    'background-color',
    'background-opacity',
    'background-pattern',
  ],
};